import service from '@/base/service'
import qs from 'qs'

const baseURL = process.env.VUE_APP_BASE_API_AI

const request = (data) => {
  return service({ ...data, ...{ baseURL } })
}

// 粘贴文档
export function batchSearchByText (data) {
      return request({
        url: 'company/batchSearchByText',
        method: 'post',
        data
      })
    }